import type { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import Forbidden from "../pages/Forbidden";
import { usePermissions } from "src/hooks/usePermissions";

interface InsightsGuardProps {
  children: ReactNode;
}

// UX gate only — real enforcement is server-side in PowerBiController (OrganizationService)
// and TenantNotificationController / QueueStatisticsController (ReportingService).
const InsightsGuard: FC<InsightsGuardProps> = ({ children }) => {
  const { hasInsightsLicense } = usePermissions();

  if (!hasInsightsLicense) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

InsightsGuard.propTypes = {
  children: PropTypes.node,
};

export default InsightsGuard;
